<template>
  <ProductPageLayout
    name="芊荨桌面时钟壁纸"
    :logo="logo"
    :hero-image="heroImage"
    lead="透明翻页与插画桌面时钟，支持鼠标穿透、农历显示与全屏屏保，让时间既好看又好用。"
    :feature-lines="featureLines"
    download-link="/ftp/packages/deskclock/DeskClockSetup.exe"
    download-file-name="DeskClockSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="多种时钟主题与桌面挂件，让桌面时间展示既美观又实用。"
    other-desc="更多主题样式与展示模式，满足不同桌面搭配需求。"
    reviews-desc="真实反馈持续驱动桌面时钟体验优化。"
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'DeskClock',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/deskclock/deskclock_48x48.png'),
      heroImage: require('@/assets/deskclock/时钟中心.png'),
      featureLines: [
        '翻页时钟 / 极简数字 / 指针表盘 / 插画主题',
        '桌面挂件 / 自定义时钟 / 全屏屏保 / 农历显示'
      ],
      metaItems: [
        { icon: 'shield', label: '安全认证' },
        { icon: 'plugin-free', label: '无插件' },
        { icon: 'ad-free', label: '无广告' }
      ],
      detailedFeatures: [
        {
          title: '时钟主题中心',
          brief: '集中浏览与切换精品主题，一眼挑到心仪样式。',
          detail: '翻页、数字、指针、插画等主题分类清晰，支持预览后一键应用到桌面，搭配壁纸更统一。',
          image: require('@/assets/deskclock/时钟中心.png')
        },
        {
          title: '桌面挂件',
          brief: '悬浮时钟常驻桌面，透明穿透不挡操作。',
          detail: '可调节大小与透明度，支持始终置顶与鼠标穿透，双屏也能记住位置，看时间不影响点图标。',
          image: require('@/assets/deskclock/桌面挂件.png')
        },
        {
          title: '翻页时钟主题',
          brief: '经典翻页动效，工作室远看也清晰。',
          detail: '大字号翻页样式适合副屏与远距离阅读，时间变化一目了然，桌面氛围感更强。',
          image: require('@/assets/deskclock/主题库-翻页.png')
        },
        {
          title: '插画主题',
          brief: '插画风格表盘，让桌面更有温度。',
          detail: '精选插画主题与粒子特效可选，既保持时钟可读性，又让桌面装饰更有层次。',
          image: require('@/assets/deskclock/主题库-插画.png')
        }
      ],
      otherFeatures: [
        { title: '极简数字', description: '干净数字表盘，高透明融入壁纸，适合追求极简桌面的用户。', iconImage: require('@/assets/deskclock/主题库-数字.png') },
        { title: '指针表盘', description: '传统指针样式，表盘细节可调，兼顾美观与读时习惯。', iconImage: require('@/assets/deskclock/主题库-指针.png') },
        { title: '全屏屏保', description: '一键全屏变座钟，教室投影空档或副屏展示都很合适。', iconImage: require('@/assets/deskclock/全屏屏保.png') },
        { title: '自定义时钟', description: '用自己的照片做成时钟背景，让桌面挂件更有个人风格。', iconImage: require('@/assets/deskclock/自定义时钟.png') }
      ],
      reviews: [
        { name: '周女士', comment: '翻页时钟特别好看，透明穿透后一点不挡桌面操作，终于不用盯任务栏小字了。', avatar: require('@/assets/deskclock/avatar1.jpg') },
        { name: '何先生', comment: '副屏挂一个大号翻页钟，剪辑时看时间很方便，主题切换也很快。', avatar: require('@/assets/deskclock/avatar2.jpg') },
        { name: '林同学', comment: '插画主题很有氛围感，农历和星期一起显示，日常桌面搭配壁纸很搭。', avatar: require('@/assets/deskclock/avatar3.jpg') },
        { name: '吴老师', comment: '全屏屏保当教室座钟很实用，界面干净，安装包也不臃肿。', avatar: require('@/assets/deskclock/avatar4.jpeg') },
        { name: '郑设计师', comment: '自定义照片时钟很加分，客户机演示时桌面观感一下子提升了。', avatar: require('@/assets/deskclock/avatar5.jpeg') },
        { name: '孙先生', comment: '指针和数字主题都够用，置顶穿透稳定，长期挂着也不卡。', avatar: require('@/assets/deskclock/avatar6.jpeg') }
      ]
    }
  }
}
</script>
